export const formatMoney = (num, compact = false, length = 6) => {
  // Handle null, undefined, empty string, or invalid values
  if (
    num === null ||
    num === undefined ||
    num === "" ||
    Number.isNaN(Number(num))
  ) {
    return "0";
  }

  // Convert to number if it's a string
  const numericValue = typeof num === "string" ? parseFloat(num) : num;

  // Double-check if conversion resulted in NaN
  if (Number.isNaN(numericValue)) {
    return "0";
  }

  const formatter = new Intl.NumberFormat(
    "en-US",
    compact
      ? `${numericValue}`.length > length
        ? { notation: "compact" }
        : {}
      : {}
  );

  return formatter.format(numericValue);
};

export const getFee = (currency, feeObject = {}) => {
  const key = Object.keys(feeObject)?.find(
    (key) => key.startsWith(currency) && key.includes("TransferFee")
  );
  return feeObject[key];
};
